// import Tabs from "../../../components/elements/Tabs";
import ActivityList from "../../../../components/sections/admin/Activity";

const Activity = ({userId=null}) => {
  // const tabs = [
  //   {
  //     label: "Activity Log",
  //     icon: "fa-light fa-history",
  //     content: <ActivityList />,
  //   },
  //   {
  //     label: "Settings",
  //     icon: "fa-light fa-gear",
  //     type: "image",
  //     content: "",
  //   },
  // ];

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-6">
        <div className="font-bold text-left text-lg xl:text-3xl text-primary m-auto">
          Activity Management
        </div>
        <ActivityList userId={userId}/>
        {/* <Tabs items={tabs} /> */}
      </div>
    </div>
  );
};

export default Activity;
